import { Injectable } from '@angular/core';
import { CountryCode } from '../../../enum/src/lib/country-code.enum';
import { AppConfig } from '../../config/app.config';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  constructor(private appConfig: AppConfig) {}

  /**
   * @description 依國別代碼取得地址下拉選單應出現幾個，國別代碼依據為 env.json 中的 countryId 設定
   * @returns 地址下拉選單數量
   */
  getSelectLevelCountByCountyId(): number {
    switch (this.appConfig.countryId) {
      case CountryCode.MALAYSIA:
        return 2;
      case CountryCode.PHILIPPINES:
        return 3;
      default:
        return 4;
    }
  }
}
